import { isEmpty, map, slice } from 'lodash'
import moment from 'moment'
import LOGIN_TO_PATIENT from '@/plugins/http/patient.js'

const addTimes = (dates, date, id, time) => {
  if (isEmpty(dates[date])) {
    dates[date] = []
  }

  dates[date].push({id, time, date})
}

const parsedDay = (date) => {
  return moment(date).format('DD/MM')
}

export default {
  doSearchSchedules (agenda) {
    this.mbloading = true
    this.showTotal = false
    this.$http.get('v1/scheduling/see/availables/' + agenda.id)
      .then(({data}) => {
        this.schedules = data
        this.mbloading = false
        this.show = true
      })
      .catch((error) => {
        this.mbloading = false
        this.showTotal = true
        this.afterFailure(error)
      })
  },
  parsedDayDate (day) {
    return moment(day).format('DD/MM')
  },
  parseTimeDate (time) {
    return time.slice(0, 5)
  },
  doLoad () {
    const dates = {}
    map(this.agenda.available_schedules, (item) => {
      const date = moment(item.date).format('YYYY-MM-DD')
      addTimes(dates, date, item.id, moment(item.date).format('HH:mm'))
    })
    const keys = Object.keys(dates)

    const schedules = map(keys, (key) => {
      const times = dates[key]

      const schedule = {
        date: parsedDay(key),
        dateComplete: key,
        times,
        showTimes: slice(times, 0, 3)
      }

      return schedule
    })

    this.schedules = slice(schedules, 0, 5)
  },
  hideForm () {
    this.showModal = false
  },
  toPreSchedule (schedule, i) {
    // Id agendamentos
    const scheduleId = schedule.schedulings_id.split(';')

    this.saveSessionStoragePreSChedules(scheduleId[i])

    // Alerta para informar que nao esta mais disponível este horario
    // precisar implementar aqui a reserva com a API
    // this.show = true

    // Direcioanando para uma url
    // window.location.href = 'http://app-v1.medibook.com.br/app/auth/login'
    window.location.href = LOGIN_TO_PATIENT + '?&ps=' + scheduleId[i]
  },
  saveSessionStoragePreSChedules (scheduleId, scheduledTime, now) {
    const pre = {id: scheduleId, time: scheduledTime, until: now}
    sessionStorage.setItem('preSchedule', JSON.stringify(pre))
  },
  showMore () {
  },
  setSchedule (value) {
    this.scheduled.push(value)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/schedule/resources/methods.js